import {FC, useEffect, useState} from 'react'
import {Link} from 'react-router-dom'
import {api, Listing, ApiError} from '../../services/api'
import {RoomCard} from '../public/RoomCard'
import {PageHead} from './ui'

const INK = '#1b1b29'
const MUTED = '#7e8299'
const ACCENT = '#039540'

/**
 * Booking starts at the room. The renter picks a room, then chooses an
 * available bed on the room's detail page (where the bed picker lives).
 */
const BookPage: FC = () => {
  const [rooms, setRooms] = useState<Listing[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    api
      .publicListings()
      .then(setRooms)
      .catch((e) => setError(e instanceof ApiError ? e.message : 'Failed to load rooms'))
      .finally(() => setLoading(false))
  }, [])

  return (
    <div>
      <PageHead icon='🛏️' eyebrow='Reserve' title='Reserve a bed' sub='Choose a room, then pick an available bed to request.' />

      {error && <div style={{background: '#fef2f2', border: '1px solid #fecaca', color: '#dc2626', borderRadius: 9, padding: '11px 14px', fontSize: 14, marginBottom: 18}}>{error}</div>}

      {loading ? (
        <div style={{padding: 40, textAlign: 'center', color: MUTED}}>Loading rooms…</div>
      ) : rooms.length === 0 ? (
        <div style={{padding: 40, textAlign: 'center', color: MUTED}}>No rooms available right now.</div>
      ) : (
        <div className='row g-4 ccp-stagger'>
          {rooms.map((r) => (
            <div className='col-12 col-md-6' key={r.id}>
              <RoomCard a={r} />
              <Link to={`/rooms/${r.slug}`} style={{display: 'inline-block', marginTop: 10, color: ACCENT, fontWeight: 700, fontSize: 14, textDecoration: 'none'}}>
                View beds & book →
              </Link>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export {BookPage}
